/*
 * API Solides
 * \"API de integração com o sistema Solides Gestão. A mesma oferece criação, edição, atualização de registros importantes para sua empresa como: Passaportes, Colaboradores, Ocorrências, Currículos e Vagas.  É obrigatório informar na URL base o parâmetro {locale} cujo os valores possvíeis são: <b>pt-BR</b>, ou <b>es</b>, ou <b>en</b>\"  Para gerar o token de acesso siga os seguintes passos: 1. Acesse https://system.solides.com/pt-BR/usuarios/sign_in e logue com seu usuário. 2. Acesse o sub-menu <b>Configurações</b> 3. Na seção <b>Ativar API de Integração</b>, clique em <b>Ativar API</b>. Isso gerará um token único que deverá ser utilizado em todas as requisições. 4. Configure a Header de sua requisição com essas duas variáveis:     - Content-Type: application/json     - authorization: Token token=<b>[SEU TOKEN]</b> 
 *
 * OpenAPI spec version: 1.0.14
 * Contact: suporte@solides.com.br
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.13
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ApiSolides) {
      root.ApiSolides = {};
    }
    root.ApiSolides.MedicinaESeguranca = factory(root.ApiSolides.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The MedicinaESeguranca model module.
   * @module model/MedicinaESeguranca
   * @version 1.0.14
   */

  /**
   * Constructs a new <code>MedicinaESeguranca</code>.
   * @alias module:model/MedicinaESeguranca
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>MedicinaESeguranca</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MedicinaESeguranca} obj Optional instance to populate.
   * @return {module:model/MedicinaESeguranca} The populated <code>MedicinaESeguranca</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('dateExamProcedure'))
        obj.dateExamProcedure = ApiClient.convertToType(data['dateExamProcedure'], 'String');
      if (data.hasOwnProperty('typeOfExamProcedure'))
        obj.typeOfExamProcedure = ApiClient.convertToType(data['typeOfExamProcedure'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('doctorName'))
        obj.doctorName = ApiClient.convertToType(data['doctorName'], 'String');
      if (data.hasOwnProperty('medicalRegister'))
        obj.medicalRegister = ApiClient.convertToType(data['medicalRegister'], 'String');
      if (data.hasOwnProperty('icd'))
        obj.icd = ApiClient.convertToType(data['icd'], 'String');
      if (data.hasOwnProperty('medicalEvaluation'))
        obj.medicalEvaluation = ApiClient.convertToType(data['medicalEvaluation'], 'String');
      if (data.hasOwnProperty('finished'))
        obj.finished = ApiClient.convertToType(data['finished'], 'Boolean');
      if (data.hasOwnProperty('able'))
        obj.able = ApiClient.convertToType(data['able'], 'Boolean');
      if (data.hasOwnProperty('dateOfNextExam'))
        obj.dateOfNextExam = ApiClient.convertToType(data['dateOfNextExam'], 'String');
      if (data.hasOwnProperty('numberOfDaysOff'))
        obj.numberOfDaysOff = ApiClient.convertToType(data['numberOfDaysOff'], 'Number');
    }
    return obj;
  }

  /**
   * data do exame/procedimento
   * @member {String} dateExamProcedure
   */
  exports.prototype.dateExamProcedure = undefined;

  /**
   * tipo de exame/procedimento
   * @member {String} typeOfExamProcedure
   */
  exports.prototype.typeOfExamProcedure = undefined;

  /**
   * descrição do exame/procedimento
   * @member {String} description
   */
  exports.prototype.description = undefined;

  /**
   * nome do médico
   * @member {String} doctorName
   */
  exports.prototype.doctorName = undefined;

  /**
   * crm do médico
   * @member {String} medicalRegister
   */
  exports.prototype.medicalRegister = undefined;

  /**
   * cid
   * @member {String} icd
   */
  exports.prototype.icd = undefined;

  /**
   * avaliação médica
   * @member {String} medicalEvaluation
   */
  exports.prototype.medicalEvaluation = undefined;

  /**
   * indica se prodecimento foi finalizado ou não
   * @member {Boolean} finished
   */
  exports.prototype.finished = undefined;

  /**
   * indica se o colaborador está apto a retornar aos trabalhos
   * @member {Boolean} able
   */
  exports.prototype.able = undefined;

  /**
   * data do próximo exame/procedimento
   * @member {String} dateOfNextExam
   */
  exports.prototype.dateOfNextExam = undefined;

  /**
   * número de dias de afastamento
   * @member {Number} numberOfDaysOff
   */
  exports.prototype.numberOfDaysOff = undefined;

  return exports;

}));
